const $inject = [];

const lbaGroup = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaGroupCtrl',
    controllerAs: 'vm',
    template: require('./lbaGroup.html')
  }
};

lbaGroup.$inject = $inject;

export default lbaGroup;



// WEBPACK FOOTER //
// ./src/components/lbaGroup/lbaGroupDir.js